import MailTockLoader from 'design-system-components/MailTockLoader/MailTockLoader';
import React, { useEffect, useState } from 'react';

import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { useRefreshToken } from 'services/authentication-api/authentication-requests';

import {
  decodeToken,
  getAuthToken,
  getNextStep,
  getRefreshToken,
  removeAuthToken,
  removeIsFreeTrialConsumed,
  removeNextStep,
  removeRefreshToken,
  useAccessToken,
} from 'utils/token-handler';

const ProtectedRoute: React.FC = () => {
  const nextStep = getNextStep();
  const navigate = useNavigate();
  const storedToken = getAuthToken();
  const userInfo = storedToken && decodeToken(storedToken);
  const { isAuthenticated } = useAccessToken();
  const refreshToken = getRefreshToken();
  const { mutate } = useRefreshToken();
  const [isValidToken, setIsValidToken] = useState(isAuthenticated);

  useEffect(() => {
    if (refreshToken && (!userInfo || userInfo?.exp <= Date.now() / 1000)) {
      mutate(refreshToken, {
        onSuccess: () => {
          setIsValidToken(true);
        },
      });
    }
  }, [refreshToken, userInfo, userInfo?.exp]);

  useEffect(() => {
    const interval = setInterval(() => {
      const authToken = getAuthToken();
      if (!authToken && !refreshToken) {
        navigate('/login');
      }
    }, 500);

    return () => {
      clearInterval(interval);
    };
  }, [navigate, userInfo]);

  useEffect(() => {
    if (userInfo && userInfo?.exp >= Date.now() / 1000) {
      const interval = setInterval(() => {
        const updatedTime = Date.now() / 1000;

        if (userInfo?.exp - updatedTime <= 60 && refreshToken) {
          mutate(refreshToken, {
            onSuccess: () => {
              setIsValidToken(true);
            },
            onError: () => {
              removeAuthToken();
              removeRefreshToken();
              removeNextStep();
              removeIsFreeTrialConsumed();
            },
          });
        } else if (userInfo?.exp <= updatedTime) {
          removeAuthToken();
          removeIsFreeTrialConsumed();

          navigate('/login');
        } else if (!getAuthToken() && !refreshToken) {
          navigate('/login');
        }
      }, 1000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [navigate, userInfo, userInfo?.exp, refreshToken, mutate, storedToken]);

  if (isAuthenticated === undefined) {
    return <MailTockLoader />;
  }

  if (isAuthenticated || isValidToken) {
    if (nextStep === 'VERIFY_EMAIL_ADDRESS') {
      return <Navigate to="/sign-up/verify" />;
    } else if (nextStep === 'ADD_COMPANY_INFO') {
      navigate('/sign-up/company-info', {
        state: {
          isCompleteProfile: true,
        },
      });
    } else {
      return <Outlet />;
    }
  }
};

export default ProtectedRoute;
